/**
 * Internal dependencies
 */
import { WMUToggleClass } from "@wakemeup/toggle-class";

/**
 * 
 */
class FieldRadioManager {

	/**
	 * @type HTMLElement
	 */
	contextElement = document;

	/**
	 * @type String
	 */
	toggleExtraContentSelector = '.wmu-field-radio.toggle-extra-content';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onDOMContentLoaded = this.onDOMContentLoaded.bind( this );

		this.contextElement.addEventListener( 'DOMContentLoaded', this.onDOMContentLoaded );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onDOMContentLoaded( event )
	{
		this.contextElement.querySelectorAll( this.toggleExtraContentSelector ).forEach( ( element ) =>
		{
			const toggleGroup = WMUToggleClass.group( {
				alwaysOneToggleOn: true,
				disableToggleLink: false,
				groupElement: element,
				toggleSelector: ':scope > .wmu-input > .wmu-input-radio-option > .wmu-input-radio-option-content > label',
				toggleArgs: {
					autoInit: false,
					targetSelector: 'closest( .wmu-input-radio-option )',
					fx: 'expand-collapse',
					fxTargetSelector: 'closest( .wmu-input-radio-option ):scope > .wmu-input-radio-option-extra-content',
				}
			} );

			const inputName = element.getAttribute( 'data-input-name' );
			let checkedIndex = -1;

			if ( inputName )
			{
				element.querySelectorAll( `input[name="${inputName}"]` ).forEach( ( inputElement, index ) =>
				{
					if ( inputElement.checked )
					{
						checkedIndex = index;
					}

					inputElement.addEventListener( 'change', ( event ) =>
					{
						if ( inputElement.checked && 'on' !== toggleGroup.toggleList[ index ].currentStatus )
						{
							toggleGroup.toggleList[ index ].setStatus( 'on' );
						}
					} );
				} );

				if ( -1 !== checkedIndex )
				{
					toggleGroup.toggleList[ checkedIndex ].setStatus( 'on' );
				}
			}
		} );
	}

}

export default FieldRadioManager;